import { Component } from '@angular/core';

@Component({
  selector: 'app-video-gallery-dialog-gallery-dialog',
  templateUrl: './video-gallery-dialog.component.html',
  styleUrls: ['./video-gallery-dialog.component.scss'],
  standalone: false
})
export class VideoGalleryDialogComponent {
}
